import { RadixSelectVariant, RX } from 'enums/radix';

export enum InputErrorType {
  None = 'None',
  Required = 'Required',
  Invalid = 'Invalid',
  InvalidBoolean = 'Invalid Boolean',
  InvalidDate = 'Invalid Date',
  InvalidNumber = 'Invalid Number',
  InvalidPassword = 'Invalid Password',
  InvalidSelection = 'Invalid Selection',
}

export const inputErrorColor = (type: InputErrorType) => {
  switch (type) {
    case InputErrorType.None: {
      return undefined;
    }

    case InputErrorType.Required: {
      return RX.CLR.INFO;
    }

    default: {
      return RX.CLR.DANGER;
    }
  }
};

export const inputErrorVariant = (
  type: InputErrorType
): RadixSelectVariant | undefined => {
  switch (type) {
    case InputErrorType.None: {
      return undefined;
    }

    default: {
      return 'soft';
    }
  }
};

export enum RegexFilter {
  Alpha,
  AlphaNumeric,
  Whitespace,
}
